<template>
  <div></div>
</template>

<script>
import Fct from "common/fct";
import Vue from "vue";
import Cookie from "vue-cookie";
import JwtDecode from "jwt-decode";

export default {
  name: "session",
  components: {},
  mixins: [Fct],
  computed: {
    cliente: {
      cache: false,
      get() {
        return this.$store.state.cliente;
      },
      set(value) {
        this.$store.dispatch("cliente/setCliente", value);
      },
    },
    production: {
      cache: false,
      get() {
        return this.$store.state.usuario;
      },
      set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      },
    },
    usuario: {
      cache: false,
      get() {
        return this.$store.state.usuario;
      },
      set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      },
    },
    jwt: {
      cache: false,
      get() {
        return this.$store.state.usuario.jwt;
      },
      set(jwt) {
        this.$store.dispatch("usuario/setJwt", jwt);
      },
    },
    sub_domain: {
      cache: false,
      get() {
        return this.$store.state.common.sub_domain;
      },
      set(value) {
        this.$store.dispatch("common/setSubDomain", value);
      },
    },
    tenant: {
      cache: false,
      get() {
        return this.$store.state.cliente.tenant;
      },
      set(value) {
        this.$store.dispatch("cliente/setTenant", value);
      },
    },
    env: {
      cache: false,
      get() {
        return this.$store.state.common.env;
      },
      set(value) {
        this.$store.dispatch("common/setEnv", value);
      },
    },
    navigation: {
      cache: false,
      get() {
        return this.$store.state.common.navigation;
      },
      set(value) {
        this.$store.dispatch("common/setNavigation", value);
      },
    },
    window: {
      cache: false,
      get() {
        return this.$store.state.common.window;
      },
      set(value) {
        this.$store.dispatch("common/setWindow", value);
      },
    },
    device: {
      cache: false,
      get() {
        return this.$store.state.common.device;
      },
    },
  },
  watch: {
    sub_domain() {},
    navigation() {},
    window() {},
    "cliente.logged"() {
      this.setTitle();
    },
    "usuario.logged"() {},
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    logout(reload) {
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
      this.clearSession(true);

      this.toRoute({ name: this.sub_domain + ".login" });
    },

    clearSession() {
      this.deleteCookie(this.getJwt());
    },

    validarAcesso(modulo) {
      return (this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1)) || this.usuario.acesso_modulo.indexOf(modulo) != -1;
    },

    validarPermissao(permissao) {
      return (this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1)) || this.usuario.acesso_permissao.indexOf(permissao) != -1;
    },

    validarPacote(pacote) {
      return (this.cliente.logged && this.cliente.logged.pacotes.indexOf(pacote)) != -1;
    },

    toRoute(route, type) {
      type = type ? type : "name";

      var query = this.$route.query;

      switch (type) {
        case "location":
          window.open(route, "_top");
          break;

        default:
          if (typeof route == "object") {
            route.query = query;
          }

          this.$router.push(route);
          break;
      }
    },

    logged() {
      var jwt = this.getJwt(),
        cookie = null;

      if (!jwt) return null;

      cookie = Cookie.get(jwt);

      return cookie;
    },

    getJwt(parse) {
      var jwt = null;

      try {
        jwt = this.env["jwt_" + this.sub_domain];

        if (!jwt) return null;

        if (parse) return JwtDecode(jwt);

        return jwt;
      } catch (error) {
        this.edAlert(error, "error");
      }
    },

    setTitle(title) {
      if (!title) {
        var to = this.$route;
        if (to.meta && to.meta.title && to.meta.navigation) {
          title = to.meta.title;
        }
      }

      switch (this.sub_domain) {
        case "web":
          document.title = title + " :: " + (this.cliente.logged ? this.cliente.logged.nome : "");
          break;

        case "empresa":
          document.title = "Area da Empresa" + (title ? " :: " + title : "");
          break;

        case "credenciada":
          document.title = "Area da Credenciada" + (title ? " :: " + title : "");
          break;

        case "parceiro":
          document.title = "Area do Parceiro" + (title ? " :: " + title : "");
          break;
      }
    },

    setCookie(key, value, _expires, toJSONString) {
      if (this.getCookie(key)) return;

      _expires = _expires ? _expires : 8;

      if (toJSONString) {
        value = JSON.stringify(value);
      }

      if (_expires == -1) {
        _expires = 720;
      }

      var date = this.addDate(_expires, null, "h");

      var test = Cookie.set(key, value, {
        expires: date,
        //secure: process.env.NODE_ENV == "production",
        secure: false,
        path: "/",
      });
    },

    getCookie(key, toJSON) {
      if (toJSON) {
        return JSON.parse(Cookie.get(key));
      }
      return Cookie.get(key);
    },

    deleteCookie(key) {
      if (Cookie.get(key)) {
        Cookie.delete(key);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// session.vue?0c04c83e